"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Language = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _language = require("../../../language");
var _fonts = require("../../../ui/fonts");
var _dropdown = require("../../../ui/dropdown");
var _templateObject;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var H5 = (0, _styledComponents.default)(_fonts.H5)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  white-space: nowrap;\n"])));
var Language = function Language(_ref) {
  var onChange = _ref.onChange;
  return /*#__PURE__*/_react.default.createElement(_language.LanguageSelect, {
    onChange: onChange,
    component: function component(_ref2) {
      var _options$find;
      var options = _ref2.options,
        value = _ref2.value,
        onChange = _ref2.onChange;
      return /*#__PURE__*/_react.default.createElement(_dropdown.Dropdown, null, /*#__PURE__*/_react.default.createElement(_dropdown.DropdownToggle, null, /*#__PURE__*/_react.default.createElement(H5, null, ((_options$find = options.find(function (el) {
        return el.value === value;
      })) !== null && _options$find !== void 0 ? _options$find : options[0]).label)), /*#__PURE__*/_react.default.createElement(_dropdown.DropdownMenu, null, options.map(function (o) {
        return /*#__PURE__*/_react.default.createElement(_dropdown.DropdownMenuItem, {
          key: o.value,
          onClick: function onClick() {
            return onChange(o.value);
          },
          title: o.label
        });
      })));
    }
  });
};
exports.Language = Language;